import { render, staticRenderFns } from "./AllCouponHistory.vue?vue&type=template&id=e87663e0&scoped=true&"
import script from "./AllCouponHistory.vue?vue&type=script&lang=js&"
export * from "./AllCouponHistory.vue?vue&type=script&lang=js&"
import style0 from "./AllCouponHistory.vue?vue&type=style&index=0&id=e87663e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e87663e0",
  null
  
)

export default component.exports